import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

// Ekstre/hareket satırındaki belgeye bağlantı (yazdırma sayfaları yeni sekmede açılır)
export function DocLink({ link, children, testid }) {
  if (!link) return <>{children}</>;
  return (
    <Link to={link} target={link.includes("/yazdir") || link.includes("/makbuz") ? "_blank" : undefined} title="Belgeyi aç"
      className="inline-flex items-center gap-1 text-blue-700 hover:text-blue-900 hover:underline underline-offset-2" data-testid={testid}>
      {children}<ExternalLink className="h-3 w-3 shrink-0" />
    </Link>
  );
}
